
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/agri-output-Harvest-and-Market-Access",
      function () {
        return require("private-next-pages/agri-output-Harvest-and-Market-Access.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/agri-output-Harvest-and-Market-Access"])
      });
    }
  